// 文本缩放粒度
import { TEXT_EFFECT_KEY, TEXT_STROKE_KEY, TEXT_FILL_LIST, TEXT_BASELINE_OFFSET } from '@src/slide/domain/ui-model/element-modeles/property/text/constants';

import { TextDirectionType } from '@src/slide/domain/ui-model/element-modeles/property/text/constants/text-style-type';

export const FONT_SCALE = 2;

// Editor默认padding ， 1倍值
export const DEFAULT_PADDING_TB = 3.685;  // 0.13厘米
export const DEFAULT_PADDING_LR = 7;     // 0.25厘米

// 默认tab size
export const DEFAULT_TAB_SIZE = 72;   // 2.54厘米

// slate 编辑态文本元素
export const SLATE_CONTENT_BOX_ATTR = 'data-slate-content-box';
export const SLATE_CONTENT_BOX_SELECTOR = `[${SLATE_CONTENT_BOX_ATTR}="true"]`;
export const SLATE_ZERO_WIDTH_ATTRIBUTE = 'data-slate-zero-width';
export const SLATE_PARA_ATTR = 'span[data-key]';

// slate 编辑态文字的直接父级
export const SLATE_CONTENT_ATTR = 'data-slate-content';

export const TEXTRUN_STYLE_KEY = [
    'backgroundColor',
    'color',
    'tdColor',
    'del',
    'fontSize',
    'fontStyle',
    'fontWeight',
    'letterSpacing',
    'fonts',
    'lang',
    'textDecoration',
    TEXT_EFFECT_KEY,
    TEXT_STROKE_KEY,
    TEXT_BASELINE_OFFSET,
].concat(TEXT_FILL_LIST);

export const PARAGRAPH_STYLE_KEY = [
    'PPTLineHeight',
    'buNone',
    'buFont',
    'character',
    'character_bullet_char',
    'buBlip',
    'buAutoNum',
    'lineHeight',
    'lineHeightIs',
    'marginLeft',
    'tabSize',
    'textAlign',
    'textIndent',
    'level',
    'tabList',
    'paddingTop',
    'paddingBottom',
];

export const SHOULD_DIVIDE_FONT_SCALE_PROPS = [
    'marginLeft',
    'tabSize',
    'textIndent',
    'paddingTop',
    'paddingBottom',
];

export const BUSTYLE_KEY = [
    'buNone',
    'buFont',
    'character',
    'character_bullet_char',
    'buBlip',
    'buAutoNum',
    'buClr',
    'buSzPct',
];

export const DEFAULT_TEXTRUN_STYLE = {
    backgroundColor: null,
    color: null,
    tdColor: null,
    del: 'none',
    fontSize: null,
    letterSpacing: null,
    fontStyle: 'normal',
    fontWeight: 'normal',
    fonts: {
        latin: '微软雅黑',
        ea: '微软雅黑',
    },
    lang: 'ea',
    textDecoration: 'none',
};

export const DEFAULT_PARAGRAPH_STYLE = {
    PPTLineHeight: 1,
    lineHeight: 1.2,
    lineHeightIs: 'percent',
    marginLeft: 0,
    tabSize: null,
    textAlign: 'left',
    textIndent: 0,
};

export const DEFAULT_TEXTBODY_STYLE = {
    wrapperStyle: {
        alignItems: 'flex-start',
        textDirection: TextDirectionType.HORIZONTAL,
    },
};
